<template>
  <div>
    <div class="b-NavMenu">
      <div class="b-container">
        <el-menu :default-active="activeIndex"
                class="el-menu-demo"
                mode="horizontal"
                @select="handleSelect"
                background-color="rgba(0,0,0,0.4)"
                text-color="#fff"
                active-text-color="rgba(0,0,0,0.7)"
                 >
          <el-submenu index="1">
            <template slot="title">About Us</template>
            <el-menu-item index="1-1">
              <router-link to="/about/en">Overview</router-link>
            </el-menu-item>
<!--            <el-menu-item index="1-2">-->
<!--              <router-link to="/about/en?id=jsnr">Mission</router-link>-->
<!--            </el-menu-item>-->
            <el-menu-item index="1-3">
              <router-link to="/about6/en?id=zhyxjd">Bases</router-link>
            </el-menu-item>

<!--            <el-menu-item index="1-6">-->
<!--              <router-link to="/about6?id=zhyxjd">转化医学基地</router-link>-->
<!--            </el-menu-item>-->
          </el-submenu>
          <el-submenu index="2">
            <template slot="title">Research Support</template>
            <el-submenu index="2-1">
              <template slot="title">Core Facilities</template>
<!--              <el-menu-item index="2-1-1">-->
<!--                <router-link to="/service1">公共仪器平台</router-link>-->
<!--              </el-menu-item>-->
              <el-submenu index="2-1-">
                <template slot="title">Cores</template>
<!--                <el-menu-item index="2-1-2">
                  <router-link to="/service6">光谱波谱质谱平台</router-link>
                </el-menu-item>-->
                <el-menu-item index="2-1-3">
                  <router-link to="/service7/en">Biotherapy Development Core</router-link>
                </el-menu-item>
                <el-menu-item index="2-1-4">
                  <router-link to="/service8/en">Drug Screening Core</router-link>
                </el-menu-item>
                <el-menu-item index="2-1-5">
                  <router-link to="/service9/en">High Performance Computing</router-link>
                </el-menu-item>
                <el-menu-item index="2-1-6">
                  <router-link to="/service10/en">Service Platform of Medical Equipment Development</router-link>
                </el-menu-item>
                <el-menu-item index="2-1-7">
                  <router-link to="/service12/en">Biomarker and Drug R&D Platform</router-link>
                </el-menu-item>
                <el-menu-item index="2-1-8">
                  <router-link to="/service13/en">Electron Microscopy & Imaging Unit</router-link>
                </el-menu-item>
                <el-menu-item index="2-1-9">
                  <router-link to="/service14/en">Surface & Properties Analysis Unit</router-link>
                </el-menu-item>
                <el-menu-item index="2-1-10">
                  <router-link to="/service15/en">The Element Analysis Unit</router-link>
                </el-menu-item>
                <el-menu-item index="2-1-11">
                  <router-link to="/service16/en">Spectrometry & Spectroscopy Unit</router-link>
                </el-menu-item>
              </el-submenu>
              <el-menu-item index="2-1-7">
                <a target="_blank" href="http://iac.sjtu.edu.cn">Instruments Reservation</a>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="2-2">
              <template slot="title">Technology Centers</template>
              <el-menu-item index="2-2-1">
                <router-link to="/service0/en">Manufacturing Technology Center for Biomedical Devices</router-link>
              </el-menu-item>
              <el-menu-item index="2-2-2">
                 <router-link to="/service2/en">Center for Biomedical Data Science</router-link>
              </el-menu-item>
             <el-menu-item index="2-2-3">
                <router-link to="/service3/en">Center for Pharmaceutical Innovation</router-link>
              </el-menu-item>
              <el-menu-item index="2-2-5">
                <router-link to="/service4/en">Biomedical Imaging Center</router-link>
              </el-menu-item>
               <el-menu-item index="2-2-4">
                <router-link to="/service5/en">Model Animal Center</router-link>
              </el-menu-item>
              <!--              <el-menu-item index="2-2-13">
                              <router-link to="/service13"> 临床验证技术中心</router-link>
                            </el-menu-item>-->
            </el-submenu>
            <el-menu-item index="2-3">
              <router-link to="/service11/en">Shared Labs</router-link>
            </el-menu-item>
<!--            <el-menu-item index="2-4">-->
<!--              <router-link to="/service12">会议服务</router-link>-->
<!--            </el-menu-item>-->
<!--            <el-menu-item index="2-5">-->
<!--              <router-link to="/service5">技术服务</router-link>-->
<!--            </el-menu-item>-->
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">Users</template>
            <el-menu-item index="3-1">
              <router-link to="/kyuser2/en">User Guide</router-link>
            </el-menu-item>
            <el-menu-item index="3-2">
              <router-link to="/kyuser3/en">User Stations</router-link>
            </el-menu-item>
<!--            <el-menu-item index="3-3">-->
<!--              <router-link to="/kyuser2">用户工作站</router-link>-->
<!--            </el-menu-item>-->
          </el-submenu>
          <el-submenu style="width:250px;" index="4">
            <template slot="title">Collaboration & Cooperation</template>
            <el-menu-item  style="width:250px;" index="4-1">
              <router-link to="/activity/en">Joint Institutes</router-link>
            </el-menu-item>
            <el-menu-item  style="width:250px;" index="4-2">
              <router-link to="/imageset/en">Research Partners</router-link>
            </el-menu-item>
<!--            <el-menu-item index="4-3">-->
<!--              <router-link to="/visitor">访问学者</router-link>-->
<!--            </el-menu-item>-->
            <el-menu-item  style="width:250px;" index="4-4">
              <router-link to="/cooperations/en">Updates</router-link>
            </el-menu-item>
<!--            <el-menu-item index="4-5">-->
<!--              <router-link to="/tang">唐仲英楼</router-link>-->
<!--            </el-menu-item>-->
          </el-submenu>
          <el-submenu index="5">
            <template slot="title">Research Programs</template>
<!--            <el-menu-item index="5-1">-->
<!--              <router-link to="/event">开放课题</router-link>-->
<!--            </el-menu-item>-->
            <el-menu-item index="5-2">
              <router-link to="/event2/en">TM Research Program</router-link>
            </el-menu-item>
            <el-menu-item index="5-3">
              <router-link to="/event1/en">STAR</router-link>
            </el-menu-item>
<!--            <el-menu-item index="5-4">-->
<!--              <router-link to="/health">Cyrus Tang Scholars</router-link>-->
<!--            </el-menu-item>-->
          </el-submenu>
<!--          <el-submenu index="6">
            <template slot="title">学习专栏</template>
            <el-menu-item index="6-1">
              <router-link to="/party">党建工作</router-link>
            </el-menu-item>
            <el-menu-item index="6-2">
              <router-link to="/party1">主题教育</router-link>
            </el-menu-item>
            <el-menu-item index="6-3">
              <router-link to="/party2">特色活动</router-link>
            </el-menu-item>
          </el-submenu>-->
        </el-menu>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  data () {
    return {
      activeIndex: '1',
    };
  },
  methods: {
    handleSelect (key, keyPath) {
      console.log(key, keyPath);
    }
  }
};
</script>
<style lang="scss">
@import "../../../assets/css/base.css";

/* 导航 */
.b-NavMenu {
  margin-top: 5px;
  .el-menu {
    background: none !important;
    // display: flex;
    // align-items: center;
    // justify-content: space-around;
  }
  .el-menu.el-menu--horizontal {
    border-bottom: 0 !important;
    text-align: center;
  }
  .el-menu--horizontal .el-menu-item {
    height: 40px !important;
    line-height: 40px !important;
    background: none !important;
    border-left: 1px solid #fff;
  }
  .el-submenu {
    width: 144.2px;
  }
  .el-menu--horizontal > .el-submenu .el-submenu__title {
    font-size: 16px!important;
    height: 40px !important;
    line-height: 40px !important;
    border-bottom: 0 solid transparent;
    background: none !important;
    //font-weight: bold!important;
    a {
      color: #fff;
    }
  }
  .el-menu-item.is-active {
    color: #fff !important;
    border-bottom: 0 !important;
    a {
      color: #fff !important;
    }
  }
  .el-menu-item {
    width: 144.2px;
  }
  .el-submenu__title i {
    color: #fff;
  }
}
.el-menu--horizontal {
  .el-menu--popup-bottom-start {
    margin-top: 0 !important;
    background: none !important;
  }
}
.el-menu--popup {
  padding: 0 !important;
  .el-submenu {
    //border-bottom: 1px solid #fff;
  }
}
.el-menu--horizontal .el-menu .el-menu-item{
  //background-color: rgba(0,0,0,0.4)!important;
}
.el-menu--horizontal .el-menu .el-submenu__title{
  background-color: rgba(0,0,0,0.4)!important;
}
.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  float: none;
  height: 40px;
  line-height: 40px;
  padding: 0 0px;
  color: #fff !important;
  text-align: center;
  //border-bottom: 1px solid #fff;
  a {
    color: #fff !important;
  }
  &:last-child {
    border-bottom: 0 !important;
  }
}

.el-menu--collapse .el-menu .el-submenu,
.el-menu--popup {
  min-width: 140px;
}
.el-menu--collapse .el-menu .el-submenu,
.el-menu--popup {
  min-width: 140px;
}
.el-menu--popup-right-start {
  margin: 0;
}
.el-submenu .el-menu-item {
  min-width: 140px;
}


</style>



// WEBPACK FOOTER //
// src/components/nav/en/index.vue